import axios from "axios";
import { Message } from "@arco-design/web-vue";
// 是否是开发环境
export const isDev = process.env.NODE_ENV === "development";
// 创建一个axios实例
const myAxios = axios.create({
  baseURL: isDev
    ? "http://localhost:8101"
    : "https://aidati-backend-233250-7-1360273280.sh.run.tcloudbase.com/",
  timeout: 60000,
  withCredentials: true,
});
// Add a request interceptor
myAxios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// 全局响应请求器
myAxios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // 打印响应数据到控制台
    console.log(response);

    // 从响应中解构出数据部分
    const { data } = response;
    // 未登录
    if (data.code === 40100) {
      // 不是获取用户信息接口，与不是登录页面，则跳转到登录页面
      if (
        !response.request.responseURL.includes("user/get/login") &&
        !window.location.pathname.includes("/user/login")
      ) {
        Message.warning("未登录，请先登录");
        window.location.href = `/user/login?redirect=${window.location.href}`;
      }
    }
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export default myAxios;
